import {
    GLTFLoader
} from "three/examples/jsm/loaders/GLTFLoader";
// import initDracoLoader from "./core/DRACOLoader";

import FragmentShader from "./Particles/fragment.glsl"
import VertexShader from "./Particles/vertex.glsl"

// import {
//     GUI
// } from "three/examples/jsm/libs/dat.gui.module.js";

import EarthFragmentShader from "./Earth/fragment.glsl"
import EarthVertexShader from "./Earth/vertex.glsl"
import * as THREE from "three";
const API = {
    exposure: 2.2,
    vAlpha: 1.0
}
export default class {
    constructor({
        manager,
        scene
    }) {
        // eslint-disable-next-line
        // var DRACOLoader = new initDracoLoader();
        var loader = new GLTFLoader(manager);
        this.vessel = new THREE.Object3D()
        this.scene = scene
        this.scene.add(this.vessel);
        // DRACOLoader.setDecoderPath("/libs/draco/");
        // loader.setDRACOLoader(new DRACOLoader());
        // DRACOLoader.getDecoderModule();
        this.radius = 1.001
        loader.load(
            "/assets/earth9.1.glb",
            gltf => {
                const mesh = gltf.scene.children[0]
                this.mesh = gltf.scene.children[0].clone();
                this.mesh.material = new THREE.ShaderMaterial({
                    // transparent: true,
                    uniforms: {
                        texture: {
                            type: "t",
                            value: mesh.material.emissiveMap
                        },
                        gamma: {
                            value: 5.215
                        },
                        vAlpha: {
                            value: .725
                        }
                    },
                    vertexShader: EarthVertexShader,
                    fragmentShader: EarthFragmentShader
                });

                // this.gui = new GUI();
                // this.gui.add(API, "exposure", 0, 100, 0.001).onChange(value => {
                //     this.mesh.material.uniforms.gamma.value = value
                // });
                // this.gui.add(API, "vAlpha", 0, 1, 0.001).onChange(value => {
                //     this.mesh.material.uniforms.vAlpha.value = value
                // });
                this.mesh.rotation.z = -Math.PI * 0.5
                this.mesh.rotation.x = Math.PI * 0.5

                this.vessel.add(this.mesh);
                this.vessel.position.y = -1.125
            },
            function(xhr) {
                console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
            },
            function() {
                console.log("An error happened");
            }
        );
    }
    mapLocations(locations) {
        // console.log(locations)
        const positions = []
        const colors = []
        const visibility = []
        locations.forEach((location) => {
            // if(location.name === 'France') {
            //     console.log(i)
            // }
            const {
                lattitude,
                longitude
            } = location.position

            const position = this.positionFromLatLng({
                lat: Number(lattitude),
                lng: Number(longitude),
                radius: this.radius + 0.0
            })
            colors.push(255, 43, 43)
            const {
                x,
                y,
                z
            } = position
            positions.push(x, y, z)
            visibility.push(1)
        })
        var geometry = new THREE.BufferGeometry();
        geometry.addAttribute(
            "position",
            new THREE.Float32BufferAttribute(positions, 3)
        );
        geometry.addAttribute(
            "visibility",
            new THREE.Float32BufferAttribute(visibility, 1)
        );
        geometry.addAttribute("color", new THREE.Float32BufferAttribute(colors, 3));

        var material = new THREE.ShaderMaterial({
            transparent: true,
            depthWrite: false,
            depthTest: false,
            uniforms: {
                texture: {
                    type: "t",
                    value: new THREE.TextureLoader().load("/assets/location.png")
                },
                uSize: {
                    value: 12.0 * Math.min(window.devicePixelRatio, 2)
                },
                uAlpha: {
                    value: 0.0
                }
            },
            vertexShader: VertexShader,
            fragmentShader: FragmentShader
        });
        this.countries = new THREE.Points(geometry, material);
        this.vessel.add(this.countries)
        // this.scene.add(this.countries);
        // this.scene.add(this.locations)
        // this.addLocation(positions[175])
    }
    addLocation({
        x,
        y,
        z
    }, idx) {
        var geometry = new THREE.BoxBufferGeometry(.01, .01, .01);
        var material = new THREE.MeshBasicMaterial({
            color: 0x00ff00
        });
        var cube = new THREE.Mesh(geometry, material);
        cube.idx = idx
        cube.position.set(x, y, z)
        // this.locations.add( cube );
        // this.scene.add( cube );

        this.locations.add(cube)
    }
    positionFromLatLng({
        lat,
        lng,
        radius
    }) {
        var phi = (90 - lat) * (Math.PI / 180);
        var theta = (lng + 180) * (Math.PI / 180);
        const x = -(radius * Math.sin(phi) * Math.cos(theta));
        const z = radius * Math.sin(phi) * Math.sin(theta);
        const y = radius * Math.cos(phi);
        const pos = new THREE.Vector3(x, y, z);
        return pos.multiplyScalar(1.0 + 0.03 * (1.0 - Math.abs(y)))
    }
    dispose() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
    }
}